import { Component, OnInit ,HostListener } from '@angular/core';
import { ChartData, ChartEvent, ChartType } from 'chart.js';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { getLocalJSON } from '../../_helpers/storage.util';
import { environment } from '../../../environments/environment';
declare var $:any;


@Component({
  selector: 'app-demo-dashboard',
  templateUrl: './demo-dashboard.component.html',
  styleUrls: ['./demo-dashboard.component.scss']
})
export class DemoDashboardComponent {


  public audiopath:any='';
  public showButton:boolean=true;
  public popshow:boolean=true;
  public ssvalue:any='00.00';
  public ppvalue:any='00.00';
  public rrvalue:any='00.00';

  public doughnutChartPlugins: any=[];

  public data:any = [
    // { x: 'Chrome', y: 61.3, DataLabelMappingName: Browser.isDevice ? 'Chrome: <br> 61.3%' : 'Chrome: 61.3%' },
    // { x: 'Safari', y: 24.6, DataLabelMappingName: Browser.isDevice ? 'Safari: <br> 24.6%' : 'Safari: 24.6%' },
    // { x: 'Edge', y: 5.0, DataLabelMappingName: 'Edge: 5.0%' },
    // { x: 'Samsung Internet', y: 2.7, DataLabelMappingName: Browser.isDevice ? 'Samsung Internet: <br> 2.7%' : 'Samsung Internet: 2.7%' },
    // { x: 'Firefox', y: 2.6, DataLabelMappingName: Browser.isDevice ? 'Firefox: <br> 2.6%' : 'Firefox: 2.6%' },
    // { x: 'Others', y: 3.6, DataLabelMappingName: Browser.isDevice ? 'Others: <br> 3.6%' :'Others: 3.6%' }
];

//Initializing Legend
public legendSettings: Object = {
    visible: false,
};
//Initializing DataLabel
public dataLabel: Object = {
    visible: true,
    name: 'DataLabelMappingName',
    position: 'Outside',
    font: {
        fontWeight: '600',
    },
    connectorStyle: { 
        length: '20px',
        type: 'Curve'
     },
};

public border: object = {
    width: 1
};
 // custom code start

 // custom code end

  public loading:boolean = true;
  public firstview:boolean = false;
  public detaildata:any=[];
  public chartShow:boolean=false;
  public AlbumList:any =[];
  public b_AlbumList:any=[];
  public doughnutChartData: any = {
    type: 'doughnut',
    labels: [ ],
    datasets: [
      { data: [] ,
      }
    ], 
    option:{
        plugins: {
          datalabels: {
            formatter: (value:any) => {
              return  '$'+value ;
            },
            display: true,
            backgroundColor: '#ccc',
            borderRadius: 3,
            font: {
              color: 'red',
              weight: 'bold',
            },
          },
          doughnutlabel: {
            labels: [
              {
                text: '',
                font: {
                  size: 20,
                  weight: 'bold',
                },
              },
              {
                text: 'total',
              },
            ],
          },
        },
    }   
  };

  public centerText: String = "Center Text";
  public chartOptions: any & { annotation: any }= {
    centerText: this.centerText,
    plugins: {
      datalabels: {
        formatter: (value:any) => {
          return  '$'+value ;
        },
        display: true,
        backgroundColor: '#ccc',
        borderRadius: 3,
        font: {
          color: 'red',
          weight: 'bold',
        },
      },
      doughnutlabel: {
        labels: [
          {
            text: '',
            font: {
              size: 20,
              weight: 'bold',
            },
          },
          {
            text: 'total',
          },
        ],
      },
    },

  };
  
  public doughnutChartType: ChartType = 'doughnut';
  public loginDetail:any =[];
  public setIn:any='';

  constructor(public router: Router, public service: GlobalService) {
    this.loginDetail = getLocalJSON('grw_login');  
    this.getData();
    if(localStorage.getItem('grw_first')){
      this.firstview = true;
      this.setIn=setInterval(()=>{
        if(this.audiopath.ended){
          this.firstview=false;
          clearInterval(this.setIn);
          $('#passlink11').trigger('click');
          $('#ProfilePost').modal('toggle');
          $('#ProfilePost').modal({backdrop: 'static', keyboard: false})  ;
          // this.router.navigate(['/edit-profile']);
        }  
     }, 2000); 
      localStorage.removeItem('grw_first');
    } else {
      this.popshow=false;
    }
  }

  ngOnInit(): void { 
  
  }

  @HostListener('wheel', ['$event']) onMouseWheel(event: WheelEvent) {
    this.firstview = false;
    clearInterval(this.setIn);
    if(this.popshow){
      $('#passlink11').trigger('click');
      $('#ProfilePost').modal('toggle');
      $('#ProfilePost').modal({backdrop: 'static', keyboard: false})  ;
      this.popshow=false;
    }
  }

  public chartClicked({ event, active }: { event: ChartEvent, active: {}[] }): void {
    // console.log(event, active);
  }

  public chartHovered({ event, active }: { event: ChartEvent, active: {}[] }): void {
    // console.log(event, active);
  }

  getData(){
  const url = "/dashboard"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) { 
        response.data.cards.filter((el:any)=>{
          if(el.title=='Purchase'){
            el.name = 'PURCHASES';
            el.link ='/purchase';
            el.class='gricon gr_ic_user_fill';
          }
          if(el.title=='Collaboration'){
            el.name = 'COLLABORATIONS';
            el.link ='/partners';
            el.class='gricon gr_ic_users';
          }
          if(el.title=='Program'){
            el.name ='PROGRAMS';
            el.link ='/programs';
            el.class='gricon gr_ic_programs';
          }
          if(el.title=='Streams'){
            el.name ='STREAMS';
            el.link ='/singles';
            el.class='gricon gr_ic_video';
          }
          if(el.title=='Album'){
            el.name ='ALBUMS';
            el.link ='/albums';
            el.class='gricon gr_ic_video_camera';
          }
        })
        var self=this;
        if(response.data.financial.length != 0){
          response.data.financial.filter((el:any)=>{ 
             var ss:any =(el.x).toUpperCase() +' ' +self.loginDetail.userCurrencySymbol + el.y;
             if(el.x=='subscription'){
              self.ssvalue=parseFloat(el.y).toFixed(2);
             }
             if(el.x=='programs'){
                self.ppvalue=parseFloat(el.y).toFixed(2);
             }
             if(el.x=='referral'){
                self.rrvalue=parseFloat(el.y).toFixed(2);
             }
            // self.doughnutChartData.labels.push(ss);
            self.doughnutChartData.datasets[0].data.push(el.y);
            
          })
          self.doughnutChartPlugins = [{
            beforeDraw(chart:any) {
              const ctx = chart.ctx;
              const txt = 'Center Text';        
              //Get options from the center object in options
              const sidePadding = 60;
              const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2)
        
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              const centerX = ((chart.chartArea.left + chart.chartArea.right) / 2);
              const centerY = ((chart.chartArea.top + chart.chartArea.bottom) / 2);
        
              //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
              const stringWidth = ctx.measureText(txt).width;
              const elementWidth = (chart.innerRadius * 2) - sidePaddingCalculated;
        
              // Find out how much the font can grow in width.
              const widthRatio = elementWidth / stringWidth;
              const newFontSize = Math.floor(30 * widthRatio);
              const elementHeight = (chart.innerRadius * 2);
        
              // Pick a new font size so it will not be larger than the height of label.
              const fontSizeToUse = Math.min(newFontSize, elementHeight);
        
              ctx.font = 13 + 'px Arial Black' ;
              ctx.fillStyle = '#ffffff';
        
              // Draw text in center
              var ss='Total :'+ self.loginDetail.userCurrencySymbol  + parseFloat(self.detaildata.totalPurchasedAmount).toFixed(2);;
              ctx.fillText(ss, centerX, centerY);
            }
          }];
        }
    //     self.data.push(    { x: 'Chrome', y: 61.3, DataLabelMappingName: Browser.isDevice ? 'Chrome: <br> 61.3%' : 'Chrome: 61.3%' },
    //     { x: 'Safari', y: 24.6, DataLabelMappingName: Browser.isDevice ? 'Safari: <br> 24.6%' : 'Safari: 24.6%' },
    //     { x: 'Edge', y: 5.0, DataLabelMappingName: 'Edge: 5.0%' },
    //     { x: 'Samsung Internet', y: 2.7, DataLabelMappingName: Browser.isDevice ? 'Samsung Internet: <br> 2.7%' : 'Samsung Internet: 2.7%' },
    //     { x: 'Firefox', y: 2.6, DataLabelMappingName: Browser.isDevice ? 'Firefox: <br> 2.6%' : 'Firefox: 2.6%' },
    //     { x: 'Others', y: 3.6, DataLabelMappingName: Browser.isDevice ? 'Others: <br> 3.6%' :'Others: 3.6%' }
    // )
        this.AlbumList=response.data.trending_video;
        if(this.AlbumList.length ==0){
          for(var i:any=1 ; i<9;i++){
            this.b_AlbumList.push(i);
          }
        } else {
          for(var i:any=this.AlbumList.length ; i<9;i++){
            this.b_AlbumList.push(i);
          }
        }    
        // localStorage.setItem('spw_video',response.data.welcome_video);
        this.detaildata=response.data; 
        this.loading=false;  
        // console.log( self.doughnutChartData);
        // console.log( self.data);
        if(self.detaildata.totalPurchasedAmount !=0 || self.detaildata.referralCount !=0  ){
          this.chartShow=true; 
        }        
        this.audiopath = document.getElementById("myAudio");   
      } else {
        this.loading=false;
        for(var i:any=1; i<9;i++){
          this.b_AlbumList.push(i);
        }
      }
    }), (error) => { this.loading =false; });
  }


  redirectCheck(){
    const bypassProfileCheck = environment.bypassProfileCheck ?? false;
    if (bypassProfileCheck || this.loginDetail.profile_complete == true) {
      if (bypassProfileCheck || this.loginDetail.stripe_account_verify == true) {
        if(bypassProfileCheck || this.loginDetail.subscription_added==true){
          this.router.navigate(["/create-post"]);
        } else {
          $('#passlink111').trigger('click');
        }
      } else {
        $("#passlink111").trigger("click");
      }
    } else {
      $("#passlink111").trigger("click");
    }
  }

  skip(){
    this.firstview=false; 
    clearInterval(this.setIn);
    $('#passlink11').trigger('click');
    $('#ProfilePost').modal('toggle');
    $('#ProfilePost').modal({backdrop: 'static', keyboard: false})  ;
  }

  plays(){
   var ss:any= document.getElementById("myAudio1");
   if(ss.paused){
    ss.play();
    this.showButton=false;
   } else {
    ss.pause();
    this.showButton=true;
   }   
  }

  redirect(item:any){
    localStorage.setItem('grw_content_id',item._id);
    this.router.navigate(['/video-detail']);
  }
}

